import * as Styles from './about.styles';
import React from 'react';


export const About: React.FC = () => {
    return (
      <Styles.AboutContainer>
        <Styles.GroupPhoto 
          src="group.jpeg"
          alt="Group Photo"
        />
        <Styles.AboutText>
          We are a group of academics and engineers who meet up to carry out training sessions in the Rust programming
          language and work on Rust projects together. We are based in London and meet up at King's College London. We 
          want to apply Rust to difficult problems and share our knowledge. Due to the popularity of Rust, you need to
          be a member to attend our events. This is to ensure that we are all on the same page when it comes to 
          progressing with Rust learning and projects. We are always looking for new members to join us and contribute. 
          Please checkout the membership applications page to apply.
        </Styles.AboutText>
      </Styles.AboutContainer>
    );
  };
